export default __webpack_public_path__ + "static/media/emmanuel.45124006.jpeg";